import { Stack } from '@mui/material';
import { ComparisonByDimensionCard } from './ComparisonByDimension/ComparisonByDimensionCard';
import {
  PerformersCard,
  PerformersCardProps,
} from './Performers/PerformersCard';
import { memo } from 'react';
import { AIInsights } from '@features/ai-insights';
import { CpgReport } from '../../api/schema';

type RealTimeOptimizationProps = {
  report: CpgReport;
  reports: PerformersCardProps['reports'];
  campaignName: string;
  aiInsights: AIInsights | null;
};

export const RealTimeOptimization = memo((props: RealTimeOptimizationProps) => {
  return (
    <Stack direction="column" gap="1rem">
      <PerformersCard
        dimensions={props.report.dimensions}
        reports={props.reports}
        aiInsights={props.aiInsights}
      />
      <ComparisonByDimensionCard {...props} />
    </Stack>
  );
});

RealTimeOptimization.displayName = 'RealTimeOptimization';
